<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
	<header>
		<v-container>
			<div class="navbar d-flex justify-center">
				<RouterLink to="login">
					<img alt="home-logo" class="logo" src="@/assets/logo-small.svg" />
				</RouterLink>
			</div>
		</v-container>
	</header>
</template>
<style scoped lang="scss">
header {
	background: #ffffff;
	border-block-end: 1px solid #d3e3f1;
}

.v-container {
	padding-block: 1rem;
}

.logo {
	max-height: 2rem;
}
</style>
